export default __webpack_public_path__ + "static/media/DranexxTransparent.7b934653.png";